import { useMemo } from "react";
import PeriodoFilter from "./PeriodoFilter";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UndoIcon from '@mui/icons-material/Undo';
import Tooltip from '@mui/material/Tooltip'; // 

//import { Box } from "@mui/material";
export default function gridColumns(data, columnNames = [], filters, handleRevertir, handleConciliar) {

  console.log(columnNames);
  return useMemo(
    () => {
      if (!data?.length) return [];
      
      // CAMBIO: Si columnNames es un objeto, usar su orden para determinar el orden de las columnas
      const orderedKeys = Array.isArray(columnNames) 
        ? Object.keys(data[0]) 
        : Object.keys(columnNames);
      
      return orderedKeys.map(function (columnId) {
        // Verificar que la columna existe en los datos
        if (!data[0].hasOwnProperty(columnId)) return null;
        
        let caption;
        let enableColumnFilter = true;
        let customCell;
        if (typeof columnNames[columnId] === 'object') {
          caption = columnNames[columnId].caption;
          enableColumnFilter = columnNames[columnId].enableColumnFilter;
          customCell = columnNames[columnId].Cell;
        } else if (typeof columnNames[columnId] === 'string') {
          caption = columnNames[columnId];
        } else {
          caption = columnId;
        }
        
        if (columnId.toLocaleLowerCase().includes('fecha')) {
          console.log("Entró a fecha (gridColumns) para:", columnId);
          return {
            // CAMBIO: Simplificar el accessor para fechas
            accessorKey: columnId,
            id: columnId,
            header: caption,
            enableColumnFilter: enableColumnFilter,
            filterVariant: 'date-range',
            muiFilterTextFieldProps: {
              sx: {
                minWidth: '160px',
              }
            },
            // CAMBIO: Función de ordenamiento optimizada para fechas
            sortingFn: (rowA, rowB, columnId) => {
              const valueA = rowA.getValue(columnId);
              const valueB = rowB.getValue(columnId);
              
              const dateA = new Date(valueA);
              const dateB = new Date(valueB);
              
              // Manejar fechas inválidas
              if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
              if (isNaN(dateA.getTime())) return 1;
              if (isNaN(dateB.getTime())) return -1;
              
              return dateA.getTime() - dateB.getTime();
            },
            Cell: ({ cell }) => {
              const dateValue = cell.getValue();
              if (!dateValue) return '';
              
              const date = new Date(dateValue);
              if (isNaN(date.getTime())) return '';
              
              return date.toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit', 
                year: 'numeric'
              });
            },
          };
        }
        if (columnId.toLocaleLowerCase().includes('periodo')) {
          return {
            id: columnId,
            accessorKey: columnId,
            header: caption,
            enableColumnFilter: enableColumnFilter,
            Filter: ({ column, header, table }) => (
              <PeriodoFilter column={column} header={header} table={table} filters={filters}
                periodOptions={columnNames[columnId]?.periodOptions} />
            ),
            Cell: ({ cell }) => cell.getValue(),
          };
        }
        if (columnId.toLocaleLowerCase().includes('importe') || columnId === 'debito' || columnId === 'credito') {
          return {
            header: caption,
            accessorKey: columnId,
            enableColumnFilter: enableColumnFilter,
            id: columnId,
            // CAMBIO: Mejorar el ordenamiento para todas las columnas monetarias
            sortingFn: (rowA, rowB, columnId) => {
              let a = rowA.getValue(columnId);
              let b = rowB.getValue(columnId);
              
              // Convertir a número si es string
              if (typeof a === 'string') {
                a = Number(a.replace(/[^0-9\-,.]/g, '').replace(',', '.'));
              }
              if (typeof b === 'string') {
                b = Number(b.replace(/[^0-9\-,.]/g, '').replace(',', '.'));
              }
              
              // Asegurar que sean números válidos
              a = Number(a) || 0;
              b = Number(b) || 0;
              
              return a - b;
            },
            filterFn: (row, id, filterValue) => {
              // CAMBIO: Usar la misma lógica que en ConciliarOps.js
              let value = row.getValue(id);
              if (typeof value === 'string') {
                value = Number(value.replace(/[^0-9\-,.]/g, '').replace(',', '.'));
              }
              value = Number(value) || 0;
              if (!filterValue) return true;
              
              // Convertir el valor a diferentes formatos para búsqueda
              const valueString = value.toString();
              const valueFormatted = value.toLocaleString('es-AR', { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
              });
              
              // Buscar el filtro en cualquiera de las representaciones
              return valueString.includes(filterValue) || 
                     valueFormatted.includes(filterValue) ||
                     value.toString().includes(filterValue);
            },
            Cell: ({ cell }) => {
              let value = cell.getValue();
              if (value === undefined || value === null || isNaN(value)) return '';
              if (typeof value === 'string') {
                value = value.replace(/[^0-9\-,.]/g, '').replace(',', '.');
              }
              value = Number(value);
              if (isNaN(value)) return '';
              return '$ ' + value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          };
        }
        if (columnId === 'razonSocial') {
          return {
            header: caption,
            accessorKey: columnId,
            enableColumnFilter: enableColumnFilter,
            id: columnId,
            filterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              if (!value || !filterValue) return true;
              return String(value).toLowerCase().includes(String(filterValue).toLowerCase());
            }
          };
        }
        if (columnId === 'acciones') {
          console.log("Entró a acciones (gridColumns)");
          return {
            header: caption,
            accessorKey: columnId,
            enableColumnFilter: enableColumnFilter,
            id: columnId,
            Cell: ({ row }) => (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip title="Revertir Conciliación">
                  <Button onClick={() => handleRevertir(row.original.id_registro)}>
                    <UndoIcon />
                  </Button>
                </Tooltip>
              </Box>
            ),
          };
        }
        if (columnId === 'accionesCO') {
          console.log("Entró a acciones CO (gridColumns)");
          return {
            header: caption,
            accessorKey: columnId,
            enableColumnFilter: enableColumnFilter,
            id: columnId,
            Cell: ({ row }) => (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip title="Conciliar">
                  <Button onClick={() => handleConciliar(row.original.id_registro, row.original.registroExtbc)}>
                    <CheckCircleIcon />
                  </Button>
                </Tooltip>
              </Box>
            ),
          };
        }
        return {
          header: caption,
          enableColumnFilter: enableColumnFilter,
          accessorKey: columnId,
          id: columnId,
          ...(customCell && { Cell: customCell }),
        };
      }).filter(Boolean); // Filtrar elementos nulos
    },
    [data, columnNames]
  );
}


//lo dejo aca por si las dudas era un filtro de rango de fechas
// Filter: ({ column, rangeFilterIndex }) => (
//   <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <DatePicker
//         onChange={newValue => {
//           column.setFilterValue(oldValues => {
//             if (typeof rangeFilterIndex === 'undefined') {
//               return newValue;
//             }
//             const newValues = oldValues ?? ['', ''];
//             newValues[rangeFilterIndex] = newValue;
//             return newValues;
//           });
//         }}
//         sx={}
//         value={
//           typeof rangeFilterIndex !== 'undefined'
//             ? column.getFilterValue()?.[rangeFilterIndex] || [null, null] // Index into the filter value
//             : column.getFilterValue() || null
//         }
//       />
//   </LocalizationProvider>
// ),